import {useAppContext} from "./useAppContext";
import {useDimensions} from "../redux/stateHooks";
import {useQuantity} from "./useQuantity";
import {contentService} from "../api/contentService";
import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {PriceModel} from "../models/domain/priceModel";
import {useSuspenseQuery} from "@apollo/client";

const DEFAULT_MODEL = new PriceModel({
    width: undefined,
    height: undefined,
    lowRange: 0,
    highRange: 0,
    unitPrice: 0,
    price: 0,
    onSale: false,
    saleAmount: undefined,
    salePercentage: undefined,
    salePrice: undefined
}, null);

export const usePriceQuery = () => {
    const {productId, currencyCode} = useAppContext();
    const {width, height} = useDimensions();
    const {quantity} = useQuantity();
    const {
        model: {
            dynamicDimensions: {isDynamic, minimumWidth, minimumHeight},
            stockInformation
        }
    } = useProductDetailsQuery();

    const {
        error,
        data
    } = useSuspenseQuery(contentService.product.price, {
        errorPolicy: "all",
        variables: {
            productId: productId,
            currencyCode: currencyCode,
            quantity: quantity,
            width: isDynamic ? width && height ? width : minimumWidth : undefined,
            height: isDynamic ? width && height ? height : minimumHeight : undefined
        },
        pollInterval: 300000
    });

    // If there is an error, break early and return the error
    if (error) return {model: DEFAULT_MODEL, error: error.message};

    const {price} = data?.product ?? {price: null};

    // If there is no price, break early and return the error
    if (!price) return {model: DEFAULT_MODEL, error: 'No price returned'};

    // Return the model to the caller
    return {model: new PriceModel(price, stockInformation)}
}

